import { memo, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useFeatureTable } from "../../../../../hooks";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { getAllowedExports } from "../../../../../utils/featureTableUtils";
import { IoDownload } from "../../../../LayerListWidget/LayerItem/ListDropdownMenu/ListDropdownMenu";
import Section from "../UI/Section/Section";
import ExportDataItem from "./ExportDataItem";

const ExportData = ({ expanded }) => {
  const [selected, setSelected] = useState(false);
  const [layers, setLayers] = useState([]);
  const { count, layerIds, layerExists } = useFeatureTable();
  const view = useSelector((state) => state.mapViewReducer.view);
  const { t } = useTranslation("common");
  const { config } = useContext(ConfigContext);

  useEffect(() => {
    if (!view) return;

    setLayers(view.map.layers.filter((layer) => layerIds[layer.id]));
  }, [count, view]);

  const filteredLayers = useMemo(() => {
    return layers.filter((l) => {
      const allowedArray = getAllowedExports(l, config) || [];
      return allowedArray.length > 0;
    });
  }, [layers, config]);

  return (
    <Section
      selected={selected}
      className="onboarding-export-layers"
      title={t("screen.widget.ExportLayers.name")}
      information={t("screen.widget.ExportLayers.information")}
      expanded={expanded}
      onClick={() => setSelected((prev) => !prev)}
      Icon={IoDownload}
    >
      {filteredLayers.map((layer) => (
        <ExportDataItem key={layer.id} layer={layer} />
      ))}
    </Section>
  );
};

export default memo(ExportData);
